import React, { useEffect, useRef, useState } from 'react';

const ImageComponent = ({ src, maxHeight = 180, title, alt }) => {
    const imageRef = useRef(null);
    const [useMaxHeight, setUseMaxHeight] = useState(false);

    useEffect(() => {
        const adjustImageSize = () => {
            if (imageRef.current) {
                const naturalHeight = imageRef.current.naturalHeight;
                if (naturalHeight > maxHeight) {
                    setUseMaxHeight(true);
                } else {
                    setUseMaxHeight(false);
                }
            }
        };

        if (imageRef.current) {
            // Wait for the image to load before checking dimensions
            if (imageRef.current.complete) {
                adjustImageSize();
            } else {
                imageRef.current.onload = adjustImageSize;
            }
        }
    }, [maxHeight]);

    return (
        <div
            className="d-flex justify-content-center align-items-center"
            style={{
                height: '180px', // Full height of the viewport
                width: '100%'
            }}
        >
            <img
                ref={imageRef}
                src={src}
                alt={alt}
                title={title}
                style={{
                    height: useMaxHeight ? `${maxHeight}px` : 'auto',
                    maxWidth: '100%',
                    objectFit: 'contain',
                    display: 'block',
                    margin: '0 auto',
                }}
            />
        </div>
    );
};

export default ImageComponent;
